import { UserNotificationSettings, NotificationType, NotificationChannel, } from "@supernova-studio/model";
export const DTOUserNotificationSettings = UserNotificationSettings;
export const DTONotificationType = NotificationType;
export const DTONotificationChannel = NotificationChannel;
